<template>
  <v-form ref="form" v-model="isValid">
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formData.key"
            label="Clave"
            :rules="[rules.required, rules.keyFormat]"
            :disabled="isEdit"
            hint="Solo letras minúsculas, números y guiones bajos"
            persistent-hint
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formData.label"
            label="Etiqueta"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-textarea
            v-model="formData.description"
            label="Descripción"
            rows="1"
            auto-grow
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="formData.type"
            :items="typeOptions"
            label="Tipo de campo"
            :rules="[rules.required]"
            @change="handleTypeChange"
          ></v-select>
        </v-col>
        <v-col v-if="formData.type === 'array'" cols="12">
          <OptionsSection v-model="formData.options" />
        </v-col>
        <v-col cols="12" md="6">
          <v-switch
            v-model="formData.required"
            label="Campo requerido"
            color="primary"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6">
          <v-switch
            v-model="formData.disabled"
            label="Campo deshabilitado"
            color="primary"
          ></v-switch>
        </v-col>
      </v-row>
      <CustomFieldExample :custom-fields="[formData]" />
    </v-container>
  </v-form>
</template>

<script>
const DEFAULT_DATA = {
  key: "",
  label: "",
  description: "",
  type: "string",
  options: [],
  required: false,
  disabled: false
};

export default {
  name: "CustomFieldForm",
  components: {
    OptionsSection: () => import("./optionsSection.vue"),
    CustomFieldExample: () => import("./CustomFieldExample.vue")
  },
  props: {
    initialData: {
      type: Object,
      default: () => DEFAULT_DATA
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isValid: false,
      formData: { ...this.initialData },
      newOption: "",
      typeOptions: [
        { text: "Texto", value: "string" },
        { text: "Número", value: "number" },
        { text: "Booleano", value: "boolean" },
        { text: "Lista de opciones", value: "array" }
      ],
      rules: {
        required: v => !!v || "Este campo es requerido",
        keyFormat: v =>
          /^[a-z0-9_]+$/.test(v) ||
          "Solo letras minúsculas, números y guiones bajos"
      }
    };
  },
  watch: {
    formData: {
      handler(newValue) {
        this.$emit("update:formData", newValue);
        this.$emit("update:isValid", this.isValid);
      },
      deep: true
    },
    initialData: {
      handler(newValue) {
        this.formData = { ...DEFAULT_DATA, ...newValue };
      },
      deep: true
    }
  },
  methods: {
    handleTypeChange() {
      if (this.formData.type !== "array") {
        this.formData.options = [];
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
      this.formData = { ...this.initialData };
      this.newOption = "";
    }
  }
};
</script>
